(function () {
    'use strict';
    angular.module('app').controller('DashboardController', DashboardController);
        DashboardController.$inject = [
            '$location', 
            'Request', 
            'Shipments', 
            'Carrier', 
            '$filter', 
            '$q', 
            'toastr',
            'CompanybySpendTableService',
            'DailyShipmentsChartService',
            'DifotChartService',
            'NonManifestedShipmentsChartService',
        ];

        function DashboardController (
            $location, 
            Request, 
            Shipments, 
            Carrier, 
            $filter, 
            $q, 
            toastr,
            CompanybySpendTableService,
            DailyShipmentsChartService,
            DifotChartService,
            NonManifestedShipmentsChartService,
        ) {
            let vm = this;
            let servicesColors = ['	rgb(48, 194, 0)', 'rgb(2, 99, 181)', 'rgb(0, 133, 194)'];

            vm.init = init;
            vm.exportCSV = exportCSV;
            vm.goTo = goTo;

            vm.init();
            
            function init() {
                // TODO: NEED TO FIND A WAY TO ADD A LOADING SPINNER HERE
                vm.accountBySpendTableData = new CompanybySpendTableService({rowClickFn : goTo}).tableData;
                vm.shipmentsDailyChartData = new DailyShipmentsChartService(servicesColors).chartData;
                vm.nonManifestedShipmentsChartData = new NonManifestedShipmentsChartService(servicesColors).chartData;
            }

            function goTo(path, params) {
                $location.path(path).search(params);
            }

            function exportCSV() {
                var columns = [];
                Shipments.exportCSV('shipment-report.csv', columns, function () {
                }, function () {
                });
            };
        }
})();



// WEBPACK FOOTER //
// ./js/controllers/DashboardController.js